// src/utils/cookies.js
export function setCookie(name, value, {
  days = 365,
  path = "/",
  sameSite = "Lax",
  secure = true,
  domain, // optional
} = {}) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;

  // ✅ FIX: use window.location instead of bare "location"
  if (secure && typeof window !== "undefined" && window.location.protocol === "https:") {
    cookie += "; Secure";
  }

  if (domain) cookie += `; Domain=${domain}`;
  document.cookie = cookie;
}

export function getCookie(name) {
  const target = `${encodeURIComponent(name)}=`;
  return document.cookie.split("; ").reduce((acc, c) => {
    if (c.startsWith(target)) return decodeURIComponent(c.slice(target.length));
    return acc;
  }, null);
}

export function eraseCookie(name, { path = "/", domain } = {}) {
  let cookie = `${encodeURIComponent(name)}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=${path}`;
  if (domain) cookie += `; Domain=${domain}`;
  document.cookie = cookie;
}
